module.exports = __webpack_public_path__ + "img/IMG_8673_L_WoodMatted_MockedUp.08b2f8ad.jpg";